import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import type { ReactNode } from "react";

type Props = {
  href: string;
  children: ReactNode;
  size?: "md" | "lg";
  className?: string;
};

export function PrimaryCta({ href, children, size = "md", className }: Props) {
  const sizing =
    size === "lg" ? "px-6 py-3 text-base" : "px-5 py-2.5 text-sm";
  return (
    <Link
      to={href}
      className={`inline-flex items-center gap-2 rounded-full bg-slate-900 ${sizing} text-white font-medium shadow-sm transition hover:bg-slate-800 dark:bg-slate-100 dark:text-slate-900 dark:hover:bg-slate-200 ${className ?? ""}`}
    >
      {children}
      <ArrowRight className="h-4 w-4" />
    </Link>
  );
}
